<template>
  <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="165">
    <!-- <Divider orientation="left">申请人基本信息</Divider> -->
    <Row :gutter="16">

      <Col span="12">
      <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人姓名" prop="applicantName">
        <Input v-model.trim="form.applicantName" disabled :maxlength="20"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人身份证号" prop="applicantIDCardNo">
        <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="申请人联系方式" prop="applicantPhone">
        <Input v-model.trim="form.applicantPhone" disabled :maxlength="40"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="户籍类型">
        <RadioGroup v-model.trim="form.applicantRegisteredResidenceType">
          <Radio :label="value" disabled v-for="{text,value} in $store.state.materiaBasicData.registeredResidenceType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']">
      <FormItem label="集体户口类型">
        <RadioGroup v-model.trim="form.applicantCollectiveAccountMaterialsType">
          <Radio :label="value" disabled v-for="{text,value} in $store.state.materiaBasicData.collectiveAccountMaterialsTypes" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <template
        v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
        <Col span="12">
        <FormItem label="上传户口簿详细地址页的首页">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantResidenceBookletMainPageGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletMainPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletMainPageGuid)" type="ios-eye" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传户口簿本人信息页">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">

              <div class="fileList" v-if="form.applicantResidenceBookletSelfPageGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletSelfPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletSelfPageGuid)" type="ios-eye" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <template v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
        <Col span="12">
        <FormItem label="派出所出具的户籍证明">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">

              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantPoliceStationRegistrationCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantPoliceStationRegistrationCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantPoliceStationRegistrationCertificateGuid)" type="ios-eye" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <Col span="24">
      <FormItem label="上传申请人居住证正面" prop="applicantResidencePermitFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantResidencePermitFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitFrontGuid)" type="ios-eye" />

                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <!-- <Col span="12">
      <FormItem label="上传申请人居住证反面" prop="applicantResidencePermitBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <div class="fileList" v-if="form.applicantResidencePermitBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitBackGuid)" type="ios-eye" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col> -->
      <Col span="12">
      <FormItem label="居住证截止时间" prop="applicantResidencePermitExpiryDate">
        <DatePicker type="date" :editable="false" disabled v-model.trim="form.applicantResidencePermitExpiryDate" style="width: 100%" />
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem class="noticeTop" label="申报事项" prop="declarationItems">
        <Input v-model.trim="form.declarationItems" disabled :maxlength="200" show-word-limit type="textarea" style="width: 100%" />
      </FormItem>
      <FormItem class="notice">
        <div>
          温馨提示：请先至上海市居住证积分办理系统（https://www.rsj.sh.gov.cn/jzzjf/）进行填报并完成申报后在至本系统进行材料上传。
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem class="noticeTop" label="是否有人事档案">
        <RadioGroup v-model.trim="form.hasPersonFiles">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem class="notice">
        <div>
          注：若申请人才为高中及以上学历，无人事档案应至户籍地人才中心建档
        </div>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles===true&&$store.state.isPassFilesManagementAptitude" label="档案是否在本单位" prop="hasPersonFiles">
        <RadioGroup v-model.trim="form.isArchiveInCurrentEnterprise">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles" label="人事档案保管机构">
        <Input v-model.trim="form.applicantArchivesCustodyInstitution" disabled :maxlength="50">
        </Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem v-show="form.hasPersonFiles===false" label="无档案证明">
        <div class="_link" v-for="item in form.noPersonFileProofGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.noPersonFileProofGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Divider orientation="left">申请人劳务合同上传</Divider>
      <Col span="12">
      <FormItem label="近6个月个人所得税完税证明" prop="applicantTaxPaymentCertificateGuidList">
        <!-- <Upload :show-upload-list="false" :default-file-list="form.applicantTaxPaymentCertificateGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'applicantTaxPaymentCertificateGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'applicantTaxPaymentCertificateGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.applicantTaxPaymentCertificateGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.applicantTaxPaymentCertificateGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="该员工是否劳务派遣" v-if="this.$store.state.enterpriseHasLaborDispatchPermit" prop="hasLaborDispatchPermit">
        <RadioGroup v-model.trim="form.hasLaborDispatchPermit">
          <Radio :label="true" disabled>是</Radio>
          <Radio :label="false" disabled>否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="12" v-if="form.hasLaborDispatchPermit===true">
      <FormItem label="派遣协议" prop="dispatchAgreementGuidList">
        <!-- <Upload :show-upload-list="false" :default-file-list="form.dispatchAgreementGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'dispatchAgreementGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'dispatchAgreementGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.dispatchAgreementGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.dispatchAgreementGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="12" v-if="form.hasLaborDispatchPermit===true">
      <FormItem label="岗位协议" prop="jobAgreementGuidList">
        <!-- <Upload :show-upload-list="false" :default-file-list="form.jobAgreementGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'jobAgreementGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'jobAgreementGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.jobAgreementGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.jobAgreementGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Col span="24">
      <!-- class="noticeTop" -->
      <FormItem label="劳动合同" prop="laborContractGuidList">
        <!-- <Upload :show-upload-list="false" :default-file-list="form.laborContractGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'laborContractGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'laborContractGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
        </Upload> -->
        <div class="_link" v-for="item in form.laborContractGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.laborContractGuidListPreview.length<1">无</span>
      </FormItem>
      </Col>
      <Divider orientation="left">申请人婚姻状况</Divider>
      <Col span="24">
      <FormItem :label="'婚姻状况'">
        <RadioGroup v-model.trim="form.applicantMaritalStatus">
          <Radio :label="value" disabled v-for="{ text, value } in $store.state.materiaBasicData
                    .maritalStatus" :key="value">{{ text }}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <template v-if="form.applicantMaritalStatus==$store.state.maritalStatusSet['初婚']||form.applicantMaritalStatus==$store.state.maritalStatusSet['再婚']">
        <Col span="24">
        <FormItem label="配偶是否是上海户籍">
          <RadioGroup @on-change="isSpouseRegisteredResidenceInSHChange" v-model.trim="form.isSpouseRegisteredResidenceInSH">
            <Radio disabled :label="true">是</Radio>
            <Radio disabled :label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
      </template>
      <Divider orientation="left">持证人同住配偶和子女是否需要享受积分相关待遇</Divider>
      <template>
        <Col span="24" v-if="form.isSpouseRegisteredResidenceInSH === false && (form.applicantMaritalStatus == $store.state.maritalStatusSet['初婚'] || form.applicantMaritalStatus == $store.state.maritalStatusSet['再婚'])">
        <!-- <FormItem label="请选择">
            <Checkbox v-show="form.isSpouseRegisteredResidenceInSH === false && (form.applicantMaritalStatus == $store.state.maritalStatusSet['初婚'] || form.applicantMaritalStatus == $store.state.maritalStatusSet['再婚'])" disabled
              v-model.trim="form.isSpouseEnjoyTreatment" label="配偶">配偶</Checkbox>
            <Checkbox disabled v-model.trim="form.isChildrenEnjoyTreatment" label="子女">子女</Checkbox>
          </FormItem> -->
        <FormItem prop="isSpouseEnjoyTreatment" label="配偶是否需要享受积分相关待遇">
          <RadioGroup v-model.trim="form.isSpouseEnjoyTreatment">
            <Radio disabled :label="true">是</Radio>
            <Radio disabled :label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem prop="isChildrenEnjoyTreatment" label="子女是否需要享受积分相关待遇">
          <RadioGroup v-model.trim="form.isChildrenEnjoyTreatment">
            <Radio disabled :label="true">是</Radio>
            <Radio disabled :label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
      </template>
      <Divider orientation="left">申请人最高学历是否为高中以上学历（不包括高中学历）</Divider>
      <Col span="24">
      <FormItem prop="hasEducation" label="请选择">
        <!-- <Checkbox v-model.trim="form.hasEducation" label="是">是</Checkbox> -->
        <RadioGroup v-model.trim="form.hasEducation">
          <Radio disabled :label="true">是</Radio>
          <Radio disabled :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <!-- <Divider orientation="left">受理中心</Divider>
      <Col span="12">
      <FormItem label="请选择" >
        <Select disabled v-model.trim="form.acceptanceCenter" placeholder="请选择" style="width:100%">
          <Option v-for="{text,value} in $store.state.materiaBasicData.acceptanceCenterOption" :value="text" :key="value">{{ text }}</Option>
        </Select>
      </FormItem>
      </Col> -->
    </Row>
  </Form>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    hasLaborDispatchPermit: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      //   ywlbList: [
      //     {
      //       name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //       value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //     },
      //   ],
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,

      rules: {},
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      if (val < this.current) {
        this.$emit('next', _this.appInfoDataType['单位基本信息'])
        return
      }

      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        let submiteUrl = `/api/services/app/JZZJFApi/SaveAppApplicantInfo`

        if (this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'], submiteUrl)
          return
        }
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'], submiteUrl)
          return
        }
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submiteUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submiteUrl)
          return
        }
      })
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    changeDateFmt(dateFmt, date, property) {
      this.$emit('changeDateFmt', dateFmt, date, property)
    },
    //户籍改变
    isSpouseRegisteredResidenceInSHChange(e) {},
  },
}
</script>